import { render, staticRenderFns } from "./PublishMenuButton.vue?vue&type=template&id=39e9118f"
import script from "./PublishMenuButton.vue?vue&type=script&lang=js"
export * from "./PublishMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports